export default {
  canSetToTerm: 'CanSetToTerm',
  canCancelAllAccounts: 'CanCancelAllAccounts',
  canManageVariations: 'CanManageVariations',
  isAdmin: 'IsAdmin',
  canManageSuspensions: 'CanManageSuspensions',
  canSuspendIgnoreSuspensionRules: 'CanSuspendIgnoreSuspensionRules',
};
